module.exports = __webpack_public_path__ + "avatar-md.a3744d02.png";